import { Link } from 'react-router-dom';
import { Home, ShieldAlert, SearchX } from 'lucide-react';
import { ROUTES } from '../../app/config';
import { Button, Card } from '../../components/ui';

function ErrorPageShell({
  code,
  icon,
  title,
  description,
}: {
  code: string;
  icon: JSX.Element;
  title: string;
  description: string;
}): JSX.Element {
  return (
    <div className="flex min-h-[60vh] items-center justify-center px-4">
      <Card className="w-full max-w-lg p-8 text-center">
        <div className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-2xl bg-surface-secondary text-text-muted">
          {icon}
        </div>
        <p className="font-mono text-sm text-text-muted">{code}</p>
        <h1 className="mt-1 text-xl font-semibold text-text-primary">{title}</h1>
        <p className="mt-2 text-sm leading-relaxed text-text-secondary">{description}</p>
        <Link to={ROUTES.home} className="mt-6 inline-block">
          <Button leftIcon={<Home className="h-4 w-4" aria-hidden />}>Volver al inicio</Button>
        </Link>
      </Card>
    </div>
  );
}

export function ForbiddenPage(): JSX.Element {
  return (
    <ErrorPageShell
      code="403"
      icon={<ShieldAlert className="h-7 w-7" aria-hidden />}
      title="Acceso denegado"
      description="Tu cuenta no tiene permisos para ver esta seccion. Si crees que se trata de un error, crea un ticket de soporte indicando a que necesitas acceder."
    />
  );
}

export function NotFoundPage(): JSX.Element {
  return (
    <ErrorPageShell
      code="404"
      icon={<SearchX className="h-7 w-7" aria-hidden />}
      title="Pagina no encontrada"
      description="La direccion a la que intentas acceder no existe o ha cambiado."
    />
  );
}
